import React, { useState } from 'react'
import SideBar from '../../../components/sidebar/Sidebar'
import { useUpdateStatus } from '../Modal/EditUserDetails/hook';
import EditUserDetails from '../Modal/EditUserDetails/EditUserDetails';
import ClientsAssign from '../Modal/ClientsAssign/ClientsAssign';
import { Link } from 'react-router-dom';
import { FiPlus } from 'react-icons/fi';
import OperationalUnderClientsList from '../Modal/OperationalUnderClients/OperationalUnderClientsList';
import AlluserTable from './AlluserTable'
import { getUserDetails } from '../Modal/EditUserDetails/api';
import { setSingleUserData } from '../Modal/EditUserDetails/slice';
import { useDispatch } from 'react-redux';

const ClientListScreen = ({ userRole = "client" }) => {

    const { alluserList } = useUpdateStatus();

    const dispatch = useDispatch()

    const [show, setShow] = useState(false);
    const [clientId, setClientId] = useState("")

    const handleClose = () => setShow(false);

    const setUserDetails = React.useCallback((user) => {
        dispatch(setSingleUserData(user))
    }, [dispatch])

    const handleShow = async (_id) => {
        setClientId(_id)
        const [data] = await getUserDetails(_id);

        if (data) {
            setUserDetails(data.response);
        }
        setShow(true)
    };

    // Clients assign model function

    const [showAssignModel, setShowAssignModel] = useState(false);


    const handleCloseAssignModel = () => setShowAssignModel(false);

    const handleShowAssignModel = (_id) => {
        setClientId(_id)
        setShowAssignModel(true)
    };

    // let options = (alluserList.filter((item) => item.role !== "operational")).map(function (user) {
    //     return { value: user._id, label: user.username };
    // })

    let options = alluserList;

    // operational under clients model function

    const [showOperationalUnderClients, setShowOperationalUnderClients] = useState(false);

    const handleCloseOperationalUnderClients = () => setShowOperationalUnderClients(false);

    const handleShowOperationalUnderClients = (_id) => {
        setClientId(_id)
        setShowOperationalUnderClients(true)
    };

    return (
        <div>
            <SideBar>

                <EditUserDetails openModal={show} closeModal={handleClose} clientId={clientId} />

                <ClientsAssign openModal={showAssignModel} closeModal={handleCloseAssignModel} clients={options} clientId={clientId} />

                <OperationalUnderClientsList openModal={showOperationalUnderClients} closeModal={handleCloseOperationalUnderClients} />

                <section className="shortlinks-page users-page" aria-labelledby="users-page-title">
                    <header className="shortlinks-page-header">
                        <h1 id="users-page-title">{userRole === "client" ? "Clients" : "Operations"}</h1>
                        <Link className="create-submit" to={userRole === "client" ? "/create-client" : "/create-operational"}>
                            <FiPlus aria-hidden="true" />
                            {userRole === "client" ? "Create new client" : "Create new operational"}
                        </Link>
                    </header>
                    <div className="shortlinks-table-shell shortlinks-table-scroll">
                        <AlluserTable
                            alluserList={alluserList.filter((item) => item.role === userRole)}
                            open={handleShow}
                            userRole={userRole}
                            handleShowAssignModel={handleShowAssignModel}
                            handleShowOperationalUnderClients={handleShowOperationalUnderClients}
                        />
                    </div>
                </section>
            </SideBar>
        </div>
    )
}

export default ClientListScreen